import React from "react";
import { withRouter } from "react-router-dom";

import { TERMS_AND_CONDITIONS } from "@/core/constants";

import { getQueryParams } from "../../utils/filters";
import { Policy } from "../../components/Policy/Policy.jsx";

const TermsAndConditionsPolicyPage = (props) => {
  const version = getQueryParams("version", props.location.search);

  return <Policy policyType={TERMS_AND_CONDITIONS} version={version} />;
};

export default withRouter(TermsAndConditionsPolicyPage);
